import { formatMoneyShorthand } from 'utils/formatMoney';

const ProgressCircle = ({
  Label = null,
  total,
  totalLabel,
  amount,
  amountLabel,
  radius = 40,
  stroke = 8,
}) => {
  const normalizedRadius = radius - stroke / 2;
  const circumference = 2 * Math.PI * normalizedRadius;
  const percent = Math.min((amount / total) * 100, 100);
  const strokeDashoffset = circumference - (percent / 100) * circumference;
  const strokeColor = percent >= 100 ? 'var(--bs-success)' : 'var(--bs-info)';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
      <svg
        height={radius * 2}
        width={radius * 2}
        style={{ display: 'block' }}
      >
        <circle
          stroke="var(--bs-gray-300)"
          fill="transparent"
          strokeWidth={stroke}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <defs>
          <linearGradient id="progress-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="var(--bs-white)" />
            <stop offset="100%" stopColor={strokeColor} />
          </linearGradient>
        </defs>
        <circle
          stroke={percent >= 100 ? 'var(--bs-success)' : 'url(#progress-gradient)'}
          fill="transparent"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          style={{ transition: 'stroke-dashoffset 0.5s' }}
          transform={`rotate(90 ${radius} ${radius})`}
        />
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dy=".3em"
          fontSize="18"
          fill="#fff"
        >
          {`${Math.round(percent)}%`}
        </text>
      </svg>
      <div>
        {Label && Label}
        <div>
          <b>{amountLabel}:</b> {formatMoneyShorthand(amount)}
        </div>
        <div>
          <b>{totalLabel}:</b> {formatMoneyShorthand(total)}
        </div>
      </div>
    </div>
  );
};

export default ProgressCircle;
